/* 🤖 this file was generated by svg-to-ts */
export const matIconBluetoothConnected: {
  name: 'bluetooth-connected';
  data: string;
} = {
  name: 'bluetooth-connected',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m7 12-2-2-2 2 2 2 2-2zm10.71-4.29L12 2h-1v7.59L6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 5.83l1.88 1.88L13 9.59V5.83zm1.88 10.46L13 18.17v-3.76l1.88 1.88zM19 10l-2 2 2 2 2-2-2-2z"/></svg>`
};
